import { Box, Grid, Paper, Typography } from '@mui/material';
import { selectReviewOnboardSlice } from 'app/pages/store/reviewOnboardSlice';
import { useAppDispatch, useAppSelector } from 'app/store';
import { savePaidolSessionId } from 'app/store/authSlice';
import { getUserCompanies } from 'app/store/userCompaniesSlice';
import { ReactComponent as PCLady } from 'assets/PurchaseCardLady.svg';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function Permission(): JSX.Element {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { integration } = useAppSelector(selectReviewOnboardSlice);
  const navigate = useNavigate();

  useEffect(() => {
    if (integration?.userId && integration?.paidolId) {
      dispatch(getUserCompanies(integration.userId));
      dispatch(savePaidolSessionId(integration.paidolId));
    }
  }, [dispatch, integration?.paidolId, integration?.userId]);

  useEffect(() => {
    if (!integration?.financialAccountId) return;
    navigate('/review/onboard', { replace: true });
  }, [integration?.financialAccountId, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
        minHeight: { xs: 'auto', md: '75vh' },
        px: 2,
      }}
    >
      <Grid
        container
        spacing={4}
        alignItems="flex-start"
        justifyContent="center"
        sx={{ maxWidth: 800, mx: 'auto' }}
      >
        <Grid
          item
          xs={12}
          md={5}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-end' },
          }}
        >
          <Box
            component={PCLady}
            aria-hidden="true"
            sx={{
              width: '100%',
              maxWidth: { xs: 220, md: 320 },
              height: 'auto',
            }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
            mt: { xs: 0, md: '60px' },
          }}
        >
          <Paper
            elevation={4}
            sx={{
              padding: 3,
              width: '100%',
              maxWidth: 420,
            }}
          >
            <Typography
              variant="h3"
              sx={{
                m: 2,
                color: 'primary.main',
              }}
            >
              {t('applicationUnderReviewTitle')}
            </Typography>
            <Box sx={{ m: 2 }}>
              <Typography variant="large">{t('applicationUnderReviewBody')}</Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Permission;
